import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Dashboard/Sidebar';
import Header from './Header';

const Layout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [hoverTooltip, setHoverTooltip] = useState({
    isVisible: false,
    text: '',
    position: { x: 0, y: 0 },
  });

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // Function to show tooltip from sidebar
  const showTooltip = (text, position) => {
    setHoverTooltip({
      isVisible: true,
      text,
      position,
    });
  };

  // Function to hide tooltip
  const hideTooltip = () => {
    setHoverTooltip((prev) => ({ ...prev, isVisible: false }));
  };

  return (
    <div className="flex min-h-screen bg-gray-200 overflow-hidden">
      {/* Sidebar */}
      <div
        className="z-20 flex-shrink-0"
        style={{
          zIndex: 20,
          transition: 'all 0.3s ease-in-out',
          width: isSidebarCollapsed ? '80px' : '287px',
        }}
      >
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          toggleSidebar={handleToggleSidebar}
          onShowTooltip={showTooltip}
          onHideTooltip={hideTooltip}
        />
      </div>

      {/* Global Tooltip */}
      {hoverTooltip.isVisible && (
        <div
          className="fixed bg-black text-white text-sm rounded px-4 py-1.5 z-50 whitespace-nowrap shadow-lg pointer-events-none font-semibold"
          style={{
            left: hoverTooltip.position.x + 10,
            top: hoverTooltip.position.y,
            transform: 'translateY(-50%)',
          }}
        >
          {hoverTooltip.text}
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Fixed Header */}
        <div
          className="fixed top-0 right-0 bg-white z-20"
          style={{
            left: isSidebarCollapsed ? '80px' : '287px',
            transition: 'all 0.2s ease-in-out',
          }}
        >
          <Header />
        </div>

        {/* Content Area */}
        <div
          className="flex-1 overflow-y-auto overflow-x-hidden mt-16 p-2"
          style={{
            marginLeft: isSidebarCollapsed ? '1px' : '1px',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          <div className="w-full">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;

// import React, { useState } from "react";
// import { Outlet } from "react-router-dom";
// import Sidebar from "../Dashboard/Sidebar";
// import Header from "./Header";

// const Layout = () => {
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
//   const [hoverTooltip, setHoverTooltip] = useState({
//     isVisible: false,
//     text: "",
//     position: { x: 0, y: 0 }
//   });

//   const handleToggleSidebar = () => {
//     setIsSidebarCollapsed(!isSidebarCollapsed);
//   };

//   // Function to show tooltip from sidebar
//   const showTooltip = (text, position) => {
//     setHoverTooltip({
//       isVisible: true,
//       text,
//       position
//     });
//   };

//   // Function to hide tooltip
//   const hideTooltip = () => {
//     setHoverTooltip(prev => ({ ...prev, isVisible: false }));
//   };

//   return (
//     <div className="flex min-h-screen bg-gray-200">
//       {/* Sidebar */}
//       <div
//         className="z-20"
//         style={{
//           zIndex: 20,
//           transition: "all 0.3s ease-in-out",
//         }}
//       >
//         <Sidebar
//           isCollapsed={isSidebarCollapsed}
//           toggleSidebar={handleToggleSidebar}
//           onShowTooltip={showTooltip}
//           onHideTooltip={hideTooltip}
//         />
//       </div>

//       {/* Global Tooltip */}
//       {hoverTooltip.isVisible && (
//         <div
//           className="fixed bg-black text-white text-sm rounded px-4 py-1.5 z-50 whitespace-nowrap shadow-lg pointer-events-none font-semibold"
//           style={{
//             left: hoverTooltip.position.x + 10,
//             top: hoverTooltip.position.y,
//             transform: 'translateY(-50%)'
//           }}
//         >
//           {hoverTooltip.text}
//         </div>
//       )}

//       {/* Main Content */}
//       <div
//         className="flex-1 relative"
//         style={{
//           transition: "all 0.3s ease-in-out",
//         }}
//       >
//         {/* Fixed Header */}
//         <div
//           className="fixed top-0 left-0 w-full z-20 bg-white"
//           style={{
//             marginLeft: isSidebarCollapsed ? "80px" : "287px",
//             width: `calc(100% - ${isSidebarCollapsed ? "80px" : "287px"})`,
//             transition: "all 0.2s ease-in-out",
//           }}
//         >
//           <Header />
//         </div>

//         {/* Content Area */}
//         <div
//           className="pt-16 p-2 text-gray-600 overflow-auto mt-2"
//           style={{
//             marginLeft: isSidebarCollapsed ? "80px" : "287px",
//             width: `calc(100% - ${isSidebarCollapsed ? "80px" : "287px"})`,
//             transition: "all 0.3s ease-in-out",
//           }}
//         >
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;
